import { render, staticRenderFns } from "./CreateOU.vue?vue&type=template&id=114eab0d&scoped=true"
import script from "./CreateOU.vue?vue&type=script&lang=js"
export * from "./CreateOU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114eab0d",
  null
  
)

export default component.exports